import React, { forwardRef, useEffect, useState, useMemo, useCallback, useRef } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes, parseSelectOptions } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';
import { Form } from 'antd';
import _ from 'lodash';

const AmazonInspectorMappingForm = forwardRef(function AmazonInspectorMappingForm(props, ref) {
  const editModeRef = useRef(!_.isEmpty(props.record));
  const [form] = Form.useForm();
  const [awsAccountList, setAWSAccountList] = useState(() => {
    if (props.record) {
      const { awsAccount } = props.record;
      return [{id: awsAccount, name: awsAccount}]
    }
    return [];
  })
  const [accountId, setAccountID] = useState(()=>{
    if (props.record) {
      const { accountId  } = props.record;
      return accountId;
    }
    return '';
  });
    const [regionList, setRegionList] = useState(() => {
      if (props.record && !_.isNull(props.record.region)) {
        const { region, awsAccount } = props.record;
        return {
          [awsAccount]: [region]
        }
      }
      return {};
    });

    useEffect(() => {
        const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
        promise.then((response) => {
          const { projects } = response;
          setAWSAccountList(projects);
        }).catch((err)=>{
          message.error('Problem fetching accounts')
        });
        
        return cancel;
    }, [props.loginConfigId, props.toolName]);

    const fetchRegions = useCallback((accountId) => {
      if((editModeRef.current && accountId) || (accountId && !regionList[accountId])){
        editModeRef.current = false;
        const {promise,cancel} = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, 
          { login_id: props.loginConfigId, organisation: accountId});

          promise.then(response=>{
            const { projects } = response;
            setRegionList((regionList) =>({...regionList,[accountId]: projects}));
          }).catch(()=>{
          message.error('Problem fetching regions')
          })

          return cancel;
      }
    }, [regionList, props.loginConfigId, props.toolName]);

    const getExtraFieldsData = useCallback((config) => {
      const { awsAccount, region } = config;

      return {
        awsAccount,
        region
      };
    }, []);

    const parseExtraFieldsDataFromResponse = useCallback((config) => {
      const { awsAccount, region } = config;
      return ({
          awsAccount, region
      });
  }, []);

    useEffect(()=> fetchRegions(accountId), [accountId, fetchRegions]);

    const onAccountChange = useCallback((value, field) => {
      setAccountID(value)
      const { name } = field;
      const configurations = form.getFieldValue("configurations") || [];
      let updatedConfiguration = [
        ...configurations,
      ];
      updatedConfiguration[name] = {
        ...updatedConfiguration[name],
        region: undefined,
      }
      form.setFieldsValue({ configurations: updatedConfiguration });
    }, [form]);

    const extraFields = useMemo(() => ([{
        name: 'awsAccount',
        colSpan: 10,
        type: FieldTypes.SELECT,
        label: 'AWS Account',
        options: awsAccountList.map(option => {
          const { label = option.name, value = option.id } = option;
          return { label, value }
        }),
        required: true,
        props: {
          autoFocus: true,
          onChange: onAccountChange
        }
      }, {
        name: 'region',
        colSpan: 12,
        type: FieldTypes.SELECT,
        label: 'Region',
        required: true,
        props: {
            getFormListOptions: (fieldKey) => {
                const configs = form.getFieldValue("configurations")
                const accountId = configs[fieldKey]?.awsAccount
                return accountId ? parseSelectOptions(regionList[accountId]): []
            },
        }
      },
    ]), [awsAccountList, onAccountChange, regionList, form]);
    return (
        <GenericMappingForm
          ref={ref}
          {...props}
          form={form}
          extraFields={extraFields}
          getExtraFieldsData={getExtraFieldsData}
          parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
        />
      )
})

export default AmazonInspectorMappingForm;